import type { IColorScheme } from '@services/BrandingsService';

export type BrandingMapColorsUnrealContext = {
  brandingId: string;
  brandingColors: IColorScheme;
  roomId?: string;
  mapId?: string;
};

/** Map palette changes — same action as spot edits, without bulk `spots` (UE expects `spot` per update). */
export const sendBrandingMapColorsUpdatedToUnreal = (
  sendMessageToUnreal: (message: unknown) => void,
  context: BrandingMapColorsUnrealContext,
) => {
  sendMessageToUnreal({
    action: 'SPOTS_UPDATED',
    brandingId: context.brandingId,
    brandingColors: context.brandingColors,
    ...(context.roomId ? { roomId: context.roomId } : {}),
    ...(context.mapId ? { mapId: context.mapId } : {}),
  });
};
